import { Link } from 'react-router-dom';

interface ServiceCardProps {
  slug: string;
  title: string;
  summary: string;
  imageUrl?: string;
}

export function ServiceCard({ slug, title, summary, imageUrl }: ServiceCardProps) {
  return (
    <Link
      to={`/cozumler/${slug}`}
      className="block bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
    >
      {imageUrl && (
        <div className="h-48 bg-gray-200 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <div className="p-6">
        <h3 className="text-xl font-semibold mb-2 text-gray-900">{title}</h3>
        <p className="text-gray-600 mb-4 line-clamp-3">{summary}</p>
        <span className="text-primary-600 font-semibold hover:underline">
          Detayları Gör →
        </span>
      </div>
    </Link>
  );
}

